import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from './ui/CTAButton';
export function GuaranteeSection() {
  return <section className="py-12 md:py-20 px-4 bg-brand-guarantee border-y-4 border-brand-green" data-id="element-159">
      <div className="max-w-4xl mx-auto text-center" data-id="element-160">
        <ShieldCheckIcon className="w-16 h-16 md:w-24 md:h-24 text-brand-green mx-auto mb-4 md:mb-6" data-id="element-161" />

        <h2 className="text-3xl md:text-5xl font-black text-brand-dark mb-5 md:mb-8 uppercase" data-id="element-162">
          🛡️ GARANTÍA BIOLOGÍA EN ACCIÓN — 7 DÍAS
        </h2>

        <div className="text-xl md:text-2xl text-gray-800 space-y-3 md:space-y-4 font-medium mb-8 md:mb-12 max-w-3xl mx-auto" data-id="element-163">
          <p data-id="element-164">
            Descargás los materiales. Los mirás. Si sentís que no te ahorran
            horas de trabajo o no se adaptan a tu aula, te devolvemos el 100% de
            tu dinero.
          </p>
          <p className="text-3xl font-black text-brand-green py-4" data-id="element-165">
            Sin preguntas. Sin vueltas.
          </p>
        </div>

        <div className="max-w-xl mx-auto" data-id="element-166">
          <CTAButton text="→ EMPEZAR HOY CON GARANTÍA" href="#compra" data-id="element-167" />
        </div>
      </div>
    </section>;
}